import TalentFavouritesData from "../../js/TalentFavouritesData";
import { useSelector } from "react-redux";
export default () => {
  const user = useSelector((state) => state.app.userData.userData);
  const filteredFavourites =
    user?.role === "employer" || user?.role === "fan"
      ? TalentFavouritesData?.filter((item) => item?.title !== "Jobs") // hide "Jobs" for employer and fan
      : TalentFavouritesData;
  return { filteredFavourites };
};
